/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum ModifyGroupIndex {
    None = 0,
    Facade = 1,
    Frame = 2,
}
